module.exports = __webpack_public_path__ + "static/media/web03_ch01.d55b6569.png";